module.exports = __webpack_public_path__ + "img/responsive hospitium-13.01e7ddaf.jpg";